module.exports = __webpack_public_path__ + "img/minus-green.3f02b874.svg";